import barba from '@barba/core';
import slide from './slide';
import slideUp from './slideUp';
import { recalculateLayoutEveryPage } from '../../utils/calculateCssVars';
import { barbaUpdateOnEnter } from './barbaUpdateOnEnter';


const onEnter = ( data, direction ) => {
  replaceDomHtml( data.next.html );
  slide( data, 'enter', direction );
};

const afterEnter = async ( data ) => {
  await slideUp( data.next.container );
  recalculateLayoutEveryPage( data.next.container );
};

// let prevUrl = window.location.href;
const barbaInit = () => {
  //https://codepen.io/thierrymichel/project/editor/XkkWWv

  // console.info( '🚀App:init' );

  barba.hooks.before( () => {
    barba.wrapper.classList.add( 'is-animating' );
  } );
  barba.hooks.after( () => {
    barba.wrapper.classList.remove( 'is-animating' );
  } );

  barba.init( {
    debug: false,
    transitions: [
      {
        sync: true,
        custom: ( data ) => ! targetHrefIsParentUrl( data ),
        leave: ( data ) => slide( data, 'leave', 'next' ),
        enter: ( data ) => {
          onEnter( data, 'next' );
        },
        afterEnter: ( data => {
          afterEnter( data );
        } ),
      },
      {
        sync: true,
        // custom: ({ trigger }) => trigger.dataset && trigger.dataset.direction === 'prev',
        custom: ( data ) => targetHrefIsParentUrl( data ),
        leave: ( data ) => slide( data, 'leave', 'prev' ),
        enter: ( data ) => {
          onEnter( data, 'prev' );
        },
        afterEnter: ( data => {
          afterEnter( data );
        } ),
      },

    ],
    prevent: ( { el } ) => {
      if ( ! el.href.includes( window.phpVars.siteUrl ) )
        return true;

      if ( el.href.includes( '/wp-admin/' ) )
        return true;

      return false;
    },
  } );

  barbaUpdateOnEnter();
};

const replaceDomHtml = ( html ) => {
  const selector = 'p5-js-extra';
  const current = document.getElementById( selector );
  let parser = new DOMParser();
  let dom = parser.parseFromString( html, 'text/html' );
  let nextProjects = dom.getElementById( selector );
  current.innerHTML = nextProjects.innerHTML;
};

const targetHrefIsParentUrl = ( data ) => {
  if ( data.trigger.classList.contains( 'barba-prev' ) ) return true;
  if ( data.trigger.classList.contains( 'barba-next' ) ) return false;

  const targetUrl = barba.history.current.url;
  const prevUrl = barba.history.previous.url;
  return prevUrl.includes( targetUrl );
};

const barbaPreventCurrentLink = () => {
  const links = document.querySelectorAll( 'a[href]' );
  const cbk = function ( e ) {
    if ( e.currentTarget.href === window.location.href ) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  for ( let i = 0; i < links.length; i++ ) {
    links[ i ].addEventListener( 'click', cbk );
  }

};

barbaInit();
barbaPreventCurrentLink();

